import { render, staticRenderFns } from "./CandidateDocsList.vue?vue&type=template&id=662f643a&scoped=true"
import script from "./CandidateDocsList.vue?vue&type=script&lang=js"
export * from "./CandidateDocsList.vue?vue&type=script&lang=js"
import style0 from "./CandidateDocsList.vue?vue&type=style&index=0&id=662f643a&prod&scoped=true&lang=css"
import style1 from "./CandidateDocsList.vue?vue&type=style&index=1&id=662f643a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662f643a",
  null
  
)

export default component.exports